module.exports = __webpack_public_path__ + "6bb776bb29138a9248f494fcd3a862e2.svg";